import { CommonModule, CurrencyPipe, DatePipe, NgOptimizedImage } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { HideDownloadDirective } from '@cargos/sprintpay-ui';
import { IMaskModule } from 'angular-imask';
import { BackButtonComponent, ImageByFacilityComponent, InvalidFieldComponent } from '../../components';
import { CompanyCustomerReferenceComponent } from '../../components/company-customer-reference/company-customer-reference.component';
import { CustomerReferenceComponent } from '../../components/customer-reference/customer-reference.component';
import { DetailsFieldComponent } from '../../components/details-section/details-field/details-field.component';
import { DetailsHeaderComponent } from '../../components/details-section/details-header/details-header.component';
import { FilesContainerComponent } from '../../components/files/files-container';
import { TableBarSelectionsComponent } from '../../components/table-bar-selections/table-bar-selections.component';
import { MatStrokedButtonBorderDirective } from '../../directives';
import { DisableControlDirective } from '../../directives/disable-control.directive';
import { DateRangeComponent } from './date-range/date-range.component';
import { DownloadConfirmationIconComponent } from './download-confirmation-icon/download-confirmation-icon.component';
import { DownloadModalComponent } from './download-modal/download-modal.component';
import { EmptyHistoryTableComponent } from './empty-history-table/empty-history-table.component';
import { PaymentDetailsComponent } from './payment-details/payment-details.component';
import { PaymentHistoryMaterialModule } from './payment-history-material-modules.module';
import { PaymentHistoryRoutingModule } from './payment-history-routing.module';
import { PaymentHistoryComponent } from './payment-history.component';
import { PrintConfirmationIconComponent } from './print-confirmation-icon/print-confirmation-icon.component';
import { SearchHistoryComponent } from './search-history/search-history.component';

@NgModule({
    imports: [
        FormsModule,
        ReactiveFormsModule,
        CommonModule,
        PaymentHistoryRoutingModule,
        PaymentHistoryMaterialModule,
        IMaskModule,
        InvalidFieldComponent,
        MatStrokedButtonBorderDirective,
        BackButtonComponent,
        DisableControlDirective,
        ImageByFacilityComponent,
        TableBarSelectionsComponent,
        CustomerReferenceComponent,
        CompanyCustomerReferenceComponent,
        DetailsHeaderComponent,
        FilesContainerComponent,
        DetailsFieldComponent,
        MatCardModule,
        HideDownloadDirective,
        NgOptimizedImage,
    ],
    providers: [CurrencyPipe, DatePipe],
    declarations: [
        PaymentHistoryComponent,
        SearchHistoryComponent,
        DownloadConfirmationIconComponent,
        DateRangeComponent,
        DownloadModalComponent,
        PrintConfirmationIconComponent,
        EmptyHistoryTableComponent,
        PaymentDetailsComponent,
    ],
    exports: [PaymentHistoryComponent],
})
export class PaymentHistoryModule {}
